export const getPositionsFromStats = (stats) =>
 stats.reduce((acc, curr) => {
  if (!acc.includes(curr.position)) return acc.concat(curr.position);
  else return acc;
 }, []);
